import React from 'react'

function LushAmenities() {
    return (
        <section id="lush-amenities">
            <div className='container my-3'>
                <h1 className='text-start fw-bold text-primary'>Amenities</h1>
                <div className='row mb-2 px-3'>
                    <div className='col-lg-4 mb-2'>
                        <div className="card border-0 h-100" style={{ background: "#325d88" }}>
                            <div id="carouselLushLobbyControls" class="carousel slide" data-bs-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <img src="/Images/Lush/Lobby1.png" class="d-block w-100" alt="..."></img>
                                    </div>
                                    <div class="carousel-item">
                                        <img src="/Images/Lush/Lobby2.png" class="d-block w-100" alt="..."></img>
                                    </div>
                                </div>
                                <button class="carousel-control-prev" type="button" data-bs-target="#carouselLushLobbyControls" data-bs-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Previous</span>
                                </button>
                                <button class="carousel-control-next" type="button" data-bs-target="#carouselLushLobbyControls" data-bs-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Next</span>
                                </button>
                            </div>
                            <div className="card-body text-white">
                                <h4 className="card-title  text-start">Lobby</h4>
                                <p className="card-text text-start">
                                    <small>
                                        Lush Residences has a hotel-like lobby on the Ground Floor where residents
                                        can entertain guests without having to enter their units. Concierge service is available.
                                    </small>
                                </p>
                                <p className="card-text text-start">
                                    <small>
                                        This development has another lobby on the 7th Floor where property
                                        owners can relax or entertain guests.
                                    </small>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4 mb-2'>
                        <div className="card border-0 h-100" style={{ background: "#325d88" }}>
                            <div id="carouselLushFunctionRoomControls" class="carousel slide" data-bs-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <img src="/Images/Lush/FunctionRoom1.png" class="d-block w-100" alt="..."></img>
                                    </div>
                                    <div class="carousel-item">
                                        <img src="/Images/Lush/FunctionRoom2.png" class="d-block w-100" alt="..."></img>
                                    </div>
                                </div>
                                <button class="carousel-control-prev" type="button" data-bs-target="#carouselLushFunctionRoomControls" data-bs-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Previous</span>
                                </button>
                                <button class="carousel-control-next" type="button" data-bs-target="#carouselLushFunctionRoomControls" data-bs-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Next</span>
                                </button>
                            </div>
                            <div className="card-body text-white">
                                <h4 className="card-title  text-start">Function Room</h4>
                                <p className="card-text text-start">
                                    <small>
                                        Residents have the option to lease a  Function Room on the Ground Floor to hold parties and events.
                                    </small>
                                </p>
                                <p className="card-text text-start">
                                    <small>
                                        No need to brave the traffic when hosting a party or event. A function room is just within the
                                        building for a resident’s convenience.
                                    </small>
                                </p>
                                <p className="card-text text-start">
                                    <small>
                                        Relax. The function room is just within the development. The resident has time to dress up and
                                        prepare for any event that he/she hosts.
                                    </small>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4 mb-2'>
                        <div className="card border-0 h-100" style={{ background: "#325d88" }}>
                            <div id="carouselLushPoolControls" class="carousel slide" data-bs-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <img src="/Images/Lush/Pool.png" class="d-block w-100" alt="..."></img>
                                    </div>
                                    <div class="carousel-item">
                                        <img src="/Images/Lush/Pool2.png" class="d-block w-100" alt="..."></img>
                                    </div>
                                </div>
                                <button class="carousel-control-prev" type="button" data-bs-target="#carouselLushPoolControls" data-bs-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Previous</span>
                                </button>
                                <button class="carousel-control-next" type="button" data-bs-target="#carouselLushPoolControls" data-bs-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Next</span>
                                </button>
                            </div>
                            <div className="card-body text-white">
                                <h4 className="card-title  text-start">Pool</h4>
                                <p className="card-text text-start">
                                    <small>
                                        For adults, there is an infinity and lap pool on the Amenity level.
                                    </small>
                                </p>
                                <p className="card-text text-start">
                                    <small>
                                        Kids will enjoy this kiddie pool within the development to help them get their dose of exercise.
                                    </small>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row mb-2 px-3'>
                    <div className='col-lg-4 mb-2'>
                        <div className="card border-0 h-100" style={{ background: "#325d88" }}>
                            <div id="carouselLushGymControls" class="carousel slide" data-bs-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <img src="/Images/Lush/Gym.png" class="d-block w-100" alt="..."></img>
                                    </div>
                                    <div class="carousel-item">
                                        <img src="/Images/Lush/Gym2.png" class="d-block w-100" alt="..."></img>
                                    </div>
                                </div>
                                <button class="carousel-control-prev" type="button" data-bs-target="#carouselLushGymControls" data-bs-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Previous</span>
                                </button>
                                <button class="carousel-control-next" type="button" data-bs-target="#carouselLushGymControls" data-bs-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Next</span>
                                </button>
                            </div>
                            <div className="card-body text-white">
                                <h4 className="card-title  text-start">Gym</h4>
                                <p className="card-text text-start">
                                    <small>
                                        Keep fit and healthy in Lush Residences with the facilities in the
                                        Fitness Gym available for use of a unit owner.
                                    </small>
                                </p>
                                <p className="card-text text-start">
                                    <small>
                                        No need to enrol in a Fitness Membership Club because within Lush Residences development
                                        is a fitness a unit owner / tenant can use.
                                    </small>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4 mb-2'>
                        <div className="card border-0 h-100" style={{ background: "#325d88" }}>
                            <div id="carouselLushGardenControls" class="carousel slide" data-bs-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <img src="/Images/Lush/Garden1.png" class="d-block w-100" alt="..."></img>
                                    </div>
                                    <div class="carousel-item">
                                        <img src="/Images/Lush/Garden2.png" class="d-block w-100" alt="..."></img>
                                    </div>
                                    <div class="carousel-item">
                                        <img src="/Images/Lush/Garden3.png" class="d-block w-100" alt="..."></img>
                                    </div>
                                    <div class="carousel-item">
                                        <img src="/Images/Lush/Garden4.png" class="d-block w-100" alt="..."></img>
                                    </div>
                                    <div class="carousel-item">
                                        <img src="/Images/Lush/Garden5.png" class="d-block w-100" alt="..."></img>
                                    </div>
                                    <div class="carousel-item">
                                        <img src="/Images/Lush/Garden6.png" class="d-block w-100" alt="..."></img>
                                    </div>
                                    <div class="carousel-item">
                                        <img src="/Images/Lush/Garden7.png" class="d-block w-100" alt="..."></img>
                                    </div>
                                </div>
                                <button class="carousel-control-prev" type="button" data-bs-target="#carouselLushGardenControls" data-bs-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Previous</span>
                                </button>
                                <button class="carousel-control-next" type="button" data-bs-target="#carouselLushGardenControls" data-bs-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Next</span>
                                </button>
                            </div>
                            <div className="card-body text-white">
                                <h4 className="card-title  text-start">Garden</h4>
                                <p className="card-text text-start">
                                    <small>
                                        Lush Residences’ sky garden allows residents to get a relaxing view of the Makati
                                        skyline and neighboring cities
                                    </small>
                                </p>
                                <p className="card-text text-start">
                                    <small>
                                        Spacious relaxation area at the sky garden.
                                        Get access to the sky garden where one can relax and unwind.
                                        Enjoy the panoramic view at the sky garden at the roofdeck.
                                    </small>
                                </p>
                                <p className="card-text text-start">
                                    <small>
                                        A mini-playground is available for kids to play in the podium garden.
                                    </small>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4 mb-2'>
                        <div className="card border-0 h-100" style={{ background: "#325d88" }}>
                            <img src="/Images/Lush/PorchArea.png" class="d-block w-100" alt="..."></img>
                            <div className="card-body text-white">
                                <h4 className="card-title  text-start">Porch Area</h4>
                                <p className="card-text text-start">
                                    <small>
                                        Relax or entertain guests at the proch area in the amenity floor.
                                    </small>
                                </p>
                                <p className="card-text text-start">
                                    <small>
                                        A relaxing area for residents can lounge and enjoy its luxurious ambience.
                                    </small>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section >
    )
}

export default LushAmenities